const AddUserToGroupPage = () => {
  return <p>access</p>
}

export default AddUserToGroupPage
